import { ColorTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, WIDGET, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { TextInputDefault } from './TextInput.default';
import { TextInputOtp } from './TextInput.otp';
/**
 * Primary UI component for user interaction
 */
const leadTextProps = {
    label: '+91 ',
    fontSize: FontSizeTokens.MD,
    color: ColorTokens.Grey_Smoke,
};
const trailTextProps = {
    label: '+91 ',
    fontSize: FontSizeTokens.MD,
    color: ColorTokens.Grey_Smoke,
};
const TextInput = ({ id, action, triggerAction, type = InputTypeToken.DEFAULT, state = InputStateToken.DEFAULT, multiline = false, onChangeText, title = 'Enter value', charLimit, secureTextEntry = false, limitLabel, showPasswordIcon, togglePasswordIcon, toggleAction, dataa, limit, keyboardType = KeyboardTypeToken.default, otpAction, value, valueInText, ref, isFocus = true, resendTimer = 15, maxPayAmount, alignErrorInBottom, customWidth, learnWhyAction, preText, showErrorOnFocus, nonZeroStartingNumberPattern, nonZeroStartingNumberPatternString, maxCharAllowed, showErrorAnimation = false, extraSpace = 0, needSearchIcon, clearTextAction, showSuccessWithoutRegex, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    switch (type) {
        case InputTypeToken.OTP:
            return (React.createElement(TextInputOtp, { id: id, ...props, charLimit: charLimit, keyboardType: KeyboardTypeToken.numberPad, state: state, type: type, onChangeText: (text) => {
                    if (onChangeText) {
                        onChangeText(text);
                    }
                    if (action && triggerAction) {
                        triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                                value: text,
                            },
                        });
                    }
                }, bgColor: ColorTokens.White, errorLabel: 'Incorrect OTP. Please try again.', loadingLabel: 'Verifying OTP', successLabel: 'Successfully verified', resendTimer: resendTimer, otpAction: otpAction, triggerAction: triggerAction }));
        case InputTypeToken.MOBILE:
            return (React.createElement(TextInputDefault, { ...props, id: id, value: value, isFocus: isFocus, keyboardType: KeyboardTypeToken.phone, state: state, type: InputTypeToken.MOBILE, title: title, limitLabel: limitLabel, charLimit: charLimit, onChangeText: (text) => {
                    if (onChangeText) {
                        onChangeText(text);
                    }
                    if (action && triggerAction) {
                        triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                                value: text,
                            },
                        });
                    }
                }, bgColor: ColorTokens.White, leadingWidget: {
                    id: 'lead_hint',
                    type: WIDGET.TEXT,
                    props: leadTextProps,
                }, triggerAction: triggerAction, preText: preText, showErrorOnFocus: showErrorOnFocus, showErrorAnimation: showErrorAnimation, extraSpace: extraSpace, needSearchIcon: needSearchIcon, clearTextAction: clearTextAction }));
        case InputTypeToken.EMAIL:
            return (React.createElement(TextInputDefault, { ...props, id: id, value: value, title: title, isFocus: isFocus, keyboardType: KeyboardTypeToken.email, state: state, type: InputTypeToken.EMAIL, onChangeText: (text) => {
                    if (onChangeText) {
                        onChangeText(text);
                    }
                    if (action && triggerAction) {
                        triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                                value: text,
                            },
                        });
                    }
                }, bgColor: ColorTokens.White, triggerAction: triggerAction, regex: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, showErrorOnFocus: showErrorOnFocus, showErrorAnimation: showErrorAnimation, extraSpace: extraSpace }));
        case InputTypeToken.SEARCH:
            {
                return (React.createElement(TextInputDefault, { id: id, ...props, value: value, title: title, keyboardType: KeyboardTypeToken.default, state: state, type: InputTypeToken.SEARCH, onChangeText: (text) => {
                        if (onChangeText) {
                            onChangeText(text);
                        }
                        if (action && triggerAction) {
                            triggerAction({
                                ...action,
                                payload: {
                                    ...action.payload,
                                    value: text,
                                },
                            });
                        }
                    }, bgColor: ColorTokens.White, triggerAction: triggerAction, trailWidget: {
                        id: 'trail_hint',
                        type: WIDGET.TEXT,
                        props: trailTextProps,
                    }, showErrorOnFocus: showErrorOnFocus, showErrorAnimation: showErrorAnimation, extraSpace: extraSpace, needSearchIcon: needSearchIcon, clearTextAction: clearTextAction }));
            }
            ;
        case InputTypeToken.MULTILINE:
            return (React.createElement(TextInputDefault, { id: id, ...props, value: value, isFocus: isFocus, title: title, limitLabel: limitLabel, secureTextEntry: secureTextEntry, charLimit: charLimit, limit: limit, keyboardType: KeyboardTypeToken.numeric, state: state, type: InputTypeToken.MULTILINE, valueInText: valueInText, onChangeText: (text) => {
                    if (onChangeText) {
                        onChangeText(text);
                    }
                    if (action && triggerAction) {
                        triggerAction({
                            ...action,
                            ...{
                                payload: {
                                    ...action.payload,
                                    value: text,
                                },
                            },
                        });
                    }
                }, bgColor: ColorTokens.White, triggerAction: triggerAction, showErrorOnFocus: showErrorOnFocus, showErrorAnimation: showErrorAnimation, extraSpace: extraSpace }));
        default:
            // @ts-ignore
            return (React.createElement(TextInputDefault, { ...props, id: id, nonZeroStartingNumberPattern: nonZeroStartingNumberPattern, nonZeroStartingNumberPatternString: nonZeroStartingNumberPatternString, maxCharAllowed: maxCharAllowed, value: value, isFocus: isFocus, title: title, limitLabel: limitLabel, secureTextEntry: secureTextEntry, charLimit: charLimit, limit: limit, keyboardType: keyboardType, state: state, alignErrorInBottom: alignErrorInBottom, showPasswordIcon: showPasswordIcon, togglePasswordIcon: togglePasswordIcon, toggleAction: toggleAction, 
                //@ts-ignore
                maxPayAmount: maxPayAmount, type: InputTypeToken.DEFAULT, onChangeText: (text) => {
                    if (onChangeText) {
                        onChangeText(text);
                    }
                    if (action && triggerAction) {
                        triggerAction({
                            ...action,
                            ...{
                                payload: {
                                    ...action.payload,
                                    value: text,
                                },
                            },
                        });
                    }
                }, bgColor: ColorTokens.White, triggerAction: triggerAction, customWidth: customWidth, showErrorOnFocus: showErrorOnFocus, showErrorAnimation: showErrorAnimation, extraSpace: extraSpace, showSuccessWithoutRegex: showSuccessWithoutRegex }));
    }
};
export default memo(TextInput);
export { TextInput };
